import * as React from 'react'
import KNB from '@wmfe/mach-pro-knb'
import { reportRaptorMetrics } from '@Common/SLRaptor'
import JudasConstant from '../../../constants/JudasConstant'
import i18nClient from '../../i18n.config'
import { pageTracker, moduleTracker } from '@/common/lx'
import './index.css'

const Login = Mach.requireModule('Login')
let isLogin = Login?.isLogin?.()
interface IProps {
  defaultKeyWord?: string
  promoFailTips: string
  onClickCloseBtn: () => void
  onClickCommitBtn: (input: string) => Promise<void>
}

interface IState {
  btnEnable: boolean // 底部按钮是否可点击
  showFailTips: boolean // 失败文案是否展示
  showDelIcon: boolean // 输入框删除按钮是否展示
  KeyboardHeight: number // 键盘高度
}

/**
 * 我的-优惠券码兑换页
 */
export default class MyCouponPromoDialog extends React.Component<IProps, IState> {
  keyword: string // 输入框内容

  searchInput: HTMLElement | null = null

  constructor (props: IProps) {
    super(props)
    this.state = {
      btnEnable: Boolean(props.defaultKeyWord),
      showFailTips: false,
      showDelIcon: Boolean(props.defaultKeyWord),
      KeyboardHeight: 0,
    }
    this.keyword = props.defaultKeyWord || ''
  }

  componentDidMount () {
    pageTracker({ cid: JudasConstant.MY_COUPON_PROMO_CID })
  }

  /**
   * 输入内容监听
   * @param e
   */
  inputChange = e => {
    const keyword = e.detail
    if (keyword === this.keyword) return
    this.keyword = keyword
    if (!keyword) {
      this.inputValClearHandle()
      return
    }
    this.setState({
      showDelIcon: true,
      btnEnable: true,
    })
  }

  /**
   * 点击输入框删除按钮
   */
  clearInput = () => {
    if (this.searchInput) {
      // @ts-ignore
      this.searchInput.setValue('')
    }
    this.keyword = ''
    this.setState({
      showDelIcon: false,
      btnEnable: false,
    })
  }

  /**
   * 清空或者点删除icon清空
   */
  inputValClearHandle = () => {
    this.keyword = ''
    this.setState({
      showDelIcon: false,
      btnEnable: false,
    })
  }

  /**
   * 输入框获得焦点
   */
  onFocus = () => {
    //
  }

  /**
   * 键盘提交监听
   */
  onConfirm = () => {
    //
  }

  /**
   * 提交按钮点击
   */
  onClickCommitBtn = () => {
    // 按钮置灰或输入词为空则不可点击
    if (!this.state.btnEnable || !this.keyword) {
      return
    }
    if (!isLogin) {
      // 上报passport调起登陆次数
      reportRaptorMetrics({ passport_need_login: 1 })
      // 调起登陆
      KNB &&
        KNB?.login({
          success (result) {
            isLogin = Login?.isLogin?.()
            // 上报passport登陆成功回调
            reportRaptorMetrics({ passport_login: 1 }, { status: 1 })
          },
          fail (error: any) {
            // 上报passport登陆失败回调
            reportRaptorMetrics({ passport_login: 0 }, { status: 2, errorCode: error?.errorCode, errorMsg: error?.errorMsg, result: error?.result })
          },
        })
      return
    }
    this.setState({
      btnEnable: false,
    })
    const { onClickCommitBtn } = this.props
    // @ts-ignore
    onClickCommitBtn && onClickCommitBtn(this.keyword)
    // 提交按钮mc
    moduleTracker({
      cid: JudasConstant.MY_COUPON_PROMO_CID,
      bid: JudasConstant.COUPON_PROMO_COMMIT_MC,
      valLab: {
        button_status: this.state.btnEnable,
        coupon_code: this.keyword,
      },
    })
  }

  /**
   * 关闭按钮点击
   */
  onClickCloseBtn = () => {
    this.focusInputBlur()
    const { onClickCloseBtn } = this.props
    // @ts-ignore
    onClickCloseBtn && onClickCloseBtn()
  }

  /**
   * 键盘高度变化监听
   * @param height
   */
  onKeyboardHeightChanged = height => {
    const KeyboardHeight = height.detail + 10
    this.setState({
      KeyboardHeight,
    })
  }

  /**
   * 取消键盘焦点（收起键盘）
   */
  focusInputBlur = () => {
    if (this.searchInput) {
      // @ts-ignore
      this.searchInput.blur()
    }
  }

  render () {
    // 数据处理
    const { promoFailTips } = this.props
    const { btnEnable, showDelIcon, KeyboardHeight } = this.state
    // i18n
    const placeHolderText = i18nClient.getText('coupon_promocode_enterbar')
    const bottomBtnText = i18nClient.getText('coupon_promocode_showlist_button')

    return (
      <view className="container" onClick={() => {}}>
        <view className="container-outer">
          <view className="container-inner">
            {/* 顶部输入框*/}
            <view className="edit-input-outer">
              <image className="edit-icon" onClick={this.onClickCloseBtn} src="assets://icon/coupon/promo_edit_left_arrow.png" autoRTL />
              <view className="edit-input-box">
                <input
                  ref={ref => {
                    this.searchInput = ref
                  }}
                  defaultValue={this.keyword}
                  className="edit-input"
                  placeholder={placeHolderText}
                  cursorColor="#222222"
                  confirmType="default"
                  placeholderColor="#808080"
                  placeholderStyle={{
                    color: '#808080',
                    fontSize: 14,
                    fontWeight: 'normal',
                    fontFamily: 'KeeTa-Regular',
                  }}
                  focus
                  disabled={false}
                  onKeyboardHeightChanged={this.onKeyboardHeightChanged}
                  onChange={this.inputChange}
                  onFocus={this.onFocus}
                  onConfirm={this.onConfirm}
                ></input>
              </view>

              {/* 删除按钮*/}
              {showDelIcon && (
                <view className="del-icon-box" onClick={this.clearInput}>
                  <image className="del-icon" src="assets://icon/coupon/promo_edit_del_icon.png" autoRTL />
                </view>
              )}
            </view>

            {/* 兑换失败提醒文案*/}
            {promoFailTips && (
              <view className="fail-tips-wrap">
                <image className="fail-tips-icon" src="assets://icon/coupon/promo_fail_tips_icon.png" autoRTL></image>
                <text className="fail-tips-text">{promoFailTips}</text>
              </view>
            )}
          </view>

          {/* 底部按钮区*/}
          <view
            className="commit-btn-wrap"
            style={{
              backgroundColor: btnEnable ? '#FFE41F' : '#CACACA',
              marginBottom: KeyboardHeight > 0 ? KeyboardHeight : 0,
            }}
            onClick={this.onClickCommitBtn}
          >
            <text className="commit-btn-text" style={{ color: btnEnable ? '#222222' : '#FFFFFF' }}>
              {bottomBtnText}
            </text>
          </view>
        </view>
      </view>
    )
  }
}
